module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-x-fill-2717821a.svg";